module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/lindsey-burns-58c4356b1e33946ac267e2b5c117113d.jpg";